(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("three-js-integration", [], factory);
	else if(typeof exports === 'object')
		exports["three-js-integration"] = factory();
	else
		root["three-js-integration"] = factory();
})(self, function() {
return 